/**
 * Silberfluss API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.10
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProcessPermissionLawyer } from './processPermissionLawyer';
import { ProcessPermissionPermission } from './processPermissionPermission';


/**
 * Permission object of process
 */
export interface ProcessPermission { 
    lawyer?: ProcessPermissionLawyer;
    permission?: ProcessPermissionPermission;
}

